import React, { Component } from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  Typography,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { Checkbox, ListItemText, Chip } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { Visibility, Add as AddIcon } from "@mui/icons-material";
import { Box, Trash } from "iconsax-react";
import { Search as SearchIcon, Block as BlockIcon } from "@mui/icons-material";
import _ from "lodash";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { Link, useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
import LinkIcon from '@mui/icons-material/Link';
const { v4: uuidv4 } = require("uuid");

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}
class Employee extends Component {
  constructor(props) {
    super(props);
    this.qrCodeRef = React.createRef();
    this.state = {
      view: false,
      add: false,
      reject: false,
      selectedEmployee: null,

      jobTitleFilter: "",
      statusFilter: "",
      searchInput: "",
      interviewPlace: "",
      interviewDate: "",
      scheduleLink: "",
      mode: "",
      candidates_id: 0,
      page: 0,
      rowsPerPage: 10,

      email: "",
      name: "",
      qr_id: "",
      video_link: "",
      redirectUrl: "",
    };
    this.debouncedSearch = _.debounce(this.handleSearch, 300);
  }
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.props.viewAllQr(
        this.props.login.token,
        this.props.login.user_id,
        this.state.searchInput,
        this.state.page,
        this.state.rowsPerPage
      );
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState(
      {
        rowsPerPage: newRowsPerPage,
        page: 0, // Reset to the first page when rows per page changes
      },
      () => {
        this.props.viewAllQr(
          this.props.login.token,
          this.props.login.user_id,
          this.state.searchInput,
          this.state.page, // Will now be 0
          this.state.rowsPerPage
        );
      }
    );
  };

  // handleFilterChange = (event) => {
  //     this.setState({ jobTitleFilter: event.target.value }, () => {
  //         this.props.viewAllCandidates(this.state.searchInput, this.state.statusFilter, this.state.jobTitleFilter);
  //     });
  // };
  // handlestatusFilterChange = (event) => {
  //     this.setState({ statusFilter: event.target.value }, () => {
  //         this.props.viewAllCandidates(this.state.searchInput, this.state.statusFilter, this.state.jobTitleFilter);
  //     });
  // };

  handleSearch = () => {
    this.props.viewAllQr(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput
    );
  };

  handleChange = (event) => {
    this.setState({ interviewer: event.target.value });
  };

  handleSearchChange = (event) => {
    const searchInput = event.target.value;
    this.setState({ searchInput }, () => {
      this.debouncedSearch();
    });
  };

  handleDialogOpen = (employee) => {
    this.setState({ selectedEmployee: employee, view: true });
  };

  handleDialogClose = () => {
    this.setState({ view: false, selectedEmployee: null });
  };

  getFilteredData = () => {
    const { tdata, jobTitleFilter, statusFilter, searchInput } = this.state;
    return tdata.filter((item) => {
      return (
        (jobTitleFilter ? item.jobtitle.includes(jobTitleFilter) : true) &&
        (statusFilter ? item.status.includes(statusFilter) : true) &&
        (searchInput
          ? item.empname.toLowerCase().includes(searchInput.toLowerCase())
          : true)
      );
    });
  };
  handleStatusChange = (event) => {
    const updatedStatus = event.target.value;
    this.setState((prevState) => ({
      selectedEmployee: {
        ...prevState.selectedEmployee,
        status: updatedStatus,
      },
      tdata: prevState.tdata.map((emp) =>
        emp.status === prevState.selectedEmployee.status
          ? { ...emp, status: updatedStatus }
          : emp
      ),
    }));
  };

  componentDidMount() {
    this.props.viewAllQr(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage
    );
    console.log(this.props.QrCode.all_qr);

  }
  handleDownload = async () => {
    if (!this.qrCodeRef.current) return;

    setTimeout(async () => {
      try {
        // Capture the QR code as an image using html2canvas
        const canvas = await html2canvas(this.qrCodeRef.current);
        const imageUrl = canvas.toDataURL("image/png");

        // Automatically download the QR code image
        const downloadLink = document.createElement("a");
        downloadLink.href = imageUrl;
        downloadLink.download = "updated_qrcode.png";
        downloadLink.click();

        // If you want to navigate after downloading, uncomment the line below
        // this.props.navigate("/qrcode");
      } catch (error) {
        console.error("Error downloading QR code:", error);
        alert("Failed to download QR code.");
      }
    }, 100);
  };

  render() {
    const {
      jobTitleFilter,
      statusFilter,
      interviewer,
      searchInput,
      selectedEmployee,
      view,
      addDialogOpen,
      interviewers,
      modes,
      reject,
    } = this.state;
    // const filteredData = this.getFilteredData();
    const { page, rowsPerPage } = this.state;
    const qr_id = uuidv4();
    return (
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
          }}>
          <TextField
            label="Search"
            value={searchInput}
            width="300"
            onChange={this.handleSearchChange}
            style={{ marginLeft: "5rem" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Link to={"/createQr"}>
            <Button
              variant="contained"
              color="primary"
            // onClick={(e) => {  }}
            >
              Create Qr Code
            </Button>
          </Link>
          {/* <Link to={"/modifyqr"}>
                        <Button variant="contained" color="primary"
                        // onClick={(e) => {  }}
                        >
                            Generate Qr
                        </Button>
                    </Link> */}
        </Grid>
        <Grid
          Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end" }}>
          <TablePagination
            component="div"
            count={this.props.QrCode.all_qrlength}
            page={page}
            onPageChange={this.handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer
            component={Paper}
            style={{
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}>
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  {[
                    "Sl No",
                    "Qr Name",
                    "Email",
                    "Link",
                    "NFC Link",
                    "Status",
                    "Action",
                  ].map((header) => (
                    <TableCell align="center" key={header}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontWeight: "bold" }}>
                        {header}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(this.props.QrCode.all_qr) &&
                  this.props.QrCode.all_qr.map((item, index) => {
                    const id = item._id;
                    const hasQrStyle =
                      Array.isArray(item.eyeColor) && item.eyeColor.length > 0;

                    return (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#fafafa" : "#ffffff",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f0f0f0" },
                        }}>
                        <TableCell align="center">
                          <Typography variant="body2">{index + 1}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            {item.name || "-"}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            {item.email || "-"}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          {item.redirectUrl ? (
                            <a
                              href={item.redirectUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "#1976d2",
                              }}>
                              Link
                            </a>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {item.link ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                              <a
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "#1976d2",
                                }}
                              >
                                {item.link}
                              </a>
                              <button
                                onClick={() => navigator.clipboard.writeText(item.link)}
                                style={{
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                Copy
                              </button>
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>

                        <TableCell align="center">
                          <Typography variant="body2">
                            {item.status || "-"}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="View QR Code">
                            {hasQrStyle ? (
                              <Link to={`/viewqrcode/${id}`}>
                                <IconButton>
                                  <Visibility color="primary" />
                                </IconButton>
                              </Link>
                            ) : (
                              <IconButton
                                onClick={() => this.handleDialogOpen(item)}>
                                <Visibility color="primary" />
                              </IconButton>
                            )}
                          </Tooltip>

                          {item?.qrType === "Dynamic" ? (
                            <>
                              <Tooltip title="Edit Link">
                                <IconButton
                                  onClick={() =>
                                    this.setState({
                                      qr_id: id,
                                      add: true,
                                      redirectUrl: item.redirectUrl,
                                    })
                                  }>
                                  <LinkIcon color="primary" fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              {/* Show Edit button only if eyeColor array is non-empty */}
                              {hasQrStyle && (
                                <Link to={`/updateqr/${id}`}>
                                  <IconButton>
                                    <QrCode2Icon style={{ color: "red", marginLeft: 4 }} />
                                  </IconButton>
                                </Link>
                              )}
                            </>
                          ) : (
                            <>
                              {hasQrStyle && (
                                <Link to={`/updateqr/${id}`}>
                                  <IconButton>
                                    <QrCode2Icon style={{ color: "red", marginLeft: 4 }} />
                                  </IconButton>
                                </Link>
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {selectedEmployee && (
          <Dialog
            open={view}
            onClose={this.handleDialogClose}
            fullWidth
            maxWidth="sm">
            <DialogTitle>QrCode Details</DialogTitle>
            <DialogContent dividers>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        QR Name
                      </TableCell>
                      <TableCell>{selectedEmployee.name}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        Email
                      </TableCell>
                      <TableCell>{selectedEmployee.email}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Link
                      </TableCell>
                      <TableCell>
                        <a
                          href={selectedEmployee.redirectUrl}
                          target="_blank"
                          rel="noopener noreferrer">
                          {selectedEmployee.redirectUrl}
                        </a>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        QR Code
                      </TableCell>
                      <TableCell align="center">
                        <img
                          src={selectedEmployee.qrCodeBase64}
                          alt="QR Code"
                          style={{ width: "300px", height: "300px" }}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDialogClose} color="primary">
                Close
              </Button>
              <Button
                color="secondary"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = selectedEmployee.qrCodeBase64;
                  link.download = `${selectedEmployee.name}-QRCode.png`;
                  link.click();
                }}>
                Download QR Code
              </Button>
            </DialogActions>
          </Dialog>
        )}

        <Dialog
          open={this.state.add}
          onClose={() => {
            this.setState({
              add: false,
              redirectUrl: "",
            });
          }}
          fullWidth>
          <DialogTitle>Add Qr Link</DialogTitle>
          <DialogContent>
            <TextField
              label="Link"
              type="text"
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={this.state.redirectUrl}
              onChange={(e) => this.setState({ redirectUrl: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                this.props.updatesQrLink(
                  this.props.login.token,
                  this.props.login.user_id,
                  this.state.qr_id,
                  this.state.redirectUrl
                );
                this.setState({
                  add: false,

                  redirectUrl: "",
                });
              }}
              color="primary">
              Add
            </Button>
            <Button
              onClick={() => {
                this.setState({
                  add: false,
                  redirectUrl: "",
                });
              }}
              color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={reject}
          onClose={() => {
            this.setState({ reject: false });
          }}>
          <DialogTitle>Confirm Reject</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to Delete the Qr Code?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                this.props.updatesStatus(this.state.qr_id, "Rejected");
                this.setState({ reject: false });
              }}
              color="primary">
              Yes
            </Button>
            <Button
              onClick={() => this.setState({ reject: false })}
              color="secondary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    );
  }
}
export default withParams(Employee);
